<template>
  <div id="app">
    <!-- desktop -->
        <tabs ref="mytab" class="d-none d-md-block" :options="{ useUrlFragment: false }" @changed="tabChanged">
          <tab name="1" > <InsulationMaterial /> </tab>
          <tab name="2" :is-disabled="tabDisabled(1)"> <ElementForm :key="`ElementLengths_tab`+$store.state.calculatorData.calculatorPages[2].disabled" /> </tab>
          <tab name="3" :is-disabled="tabDisabled(2)" :suffix="$store.getters.pageError('elementLengths') ? '<span class=\'badge badge-danger\'>!</bspan>' : ''" > <ElementLengths :key="`ElementLengths_tab`+$store.state.calculatorData.calculatorPages[3].disabled" /> </tab>
          <tab name="4" :is-disabled="tabDisabled(3)" :suffix="$store.getters.pageError('elementHeights') ? '<span class=\'badge badge-danger\'>!</bspan>' : ''" > <ElementHeights  :key="`ElementHeights_tab`+disabledStatusTab4" /> </tab>
          <tab name="5" :is-disabled="tabDisabled(4)" :suffix="$store.getters.pageError('elementWidths') ? '<span class=\'badge badge-danger\'>!</bspan>' : ''" > <ElementWidths  :key="`ElementWidths_tab`+ disabledStatusTab5" /> </tab>
          <tab name="6" :is-disabled="tabDisabled(5)" :suffix="$store.getters.pageError('vacuumPanels') ? '<span class=\'badge badge-danger\'>!</bspan>' : ''" > <VacuumPanels :key="`VacuumPanels_tab`+disabledStatusTab6" /> </tab>
          <tab name="7" :is-disabled="tabDisabled(6)" :suffix="$store.getters.pageError('notches') ? '<span class=\'badge badge-danger\'>!</bspan>' : ''" > <Notches  :key="`Notches_tab`+disabledStatusTab7"/> </tab>
          <tab name="8" :is-disabled="tabDisabled(7)" :suffix="$store.getters.pageError('profiles') ? '<span class=\'badge badge-danger\'>!</bspan>' : ''"> <EndProfiles :key="`EndProfiles_tab`+disabledStatusTab8" /></tab>
          <!-- <tab name="9"> <MountingBracket /></tab> -->
          <tab :name="$t(`summary.tabTitle`)" :is-disabled="tabDisabled(8)"> <FinalSummary :key="`FinalSummary_tab`+disabledStatusTab8" /></tab>
          <tab :name="$t(`contact.title`)"> <Contact type="desktop" /></tab>
          <tab :name="$t(`merchandiserView.title`)"> <MerchandiserView /></tab>
        </tabs>

    <!-- mobile -->
    <div class="container d-md-none">
      <div class="row d-md-none">
        <div role="tablist" class="accordion-wrapper">
          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#1" v-b-toggle.accordion-insulationMaterial variant="info" id="header-accordion-insulationMaterial">
                1 - {{ $t(`insulationMaterial.title`)}}
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-insulationMaterial')" id="accordion-insulationMaterial" visible accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <InsulationMaterial />
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#2" v-b-toggle.accordion-elementForm variant="info" id="header-accordion-elementForm" :disabled="tabDisabled(1)" :class="{collapsed : !tabDisabled(1)}">
                2 - {{ $t(`elementForm.title`)}}
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-elementForm')" id="accordion-elementForm" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <ElementForm />
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#3" v-b-toggle.accordion-elementLengths variant="info" id="header-accordion-elementLengths" :disabled="tabDisabled(2)" :class="{collapsed : !tabDisabled(2)}">
                3 - {{ $t(`elementLengths.title`)}}
                <b-badge v-if="$store.getters.pageError('elementLengths')" variant="danger">!</b-badge>
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-elementLengths')" id="accordion-elementLengths" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <ElementLengths />
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#4" v-b-toggle.accordion-elementHeights variant="info" id="header-accordion-elementHeights" :disabled="tabDisabled(3)" :class="{collapsed : !tabDisabled(3)}">
                4 - {{ $t(`elementHeights.title`)}}
                <b-badge v-if="$store.getters.pageError('elementHeights')" variant="danger">!</b-badge>
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-elementHeights')" id="accordion-elementHeights" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <ElementHeights />
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#5" v-b-toggle.accordion-elementWidths variant="info" id="header-accordion-elementWidths" :disabled="tabDisabled(4)" :class="{collapsed : !tabDisabled(4)}">
                5 - {{ $t(`elementWidths.title`)}}
                <b-badge v-if="$store.getters.pageError('elementWidths')" variant="danger">!</b-badge>
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-elementWidths')" id="accordion-elementWidths" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <ElementWidths />
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#6" v-b-toggle.accordion-vacuumPanels variant="info" id="header-accordion-vacuumPanels" :disabled="tabDisabled(5)" :class="{collapsed : !tabDisabled(5)}">
                6 - {{ $t(`vacuumPanels.title`)}}
                <b-badge v-if="$store.getters.pageError('vacuumPanels')" variant="danger">!</b-badge>
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-vacuumPanels')" id="accordion-vacuumPanels" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <VacuumPanels />
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#7" v-b-toggle.accordion-notches variant="info" id="header-accordion-notches" :disabled="tabDisabled(6)" :class="{collapsed : !tabDisabled(6)}">
                7 - {{ $t(`notches.title`)}}
                <!-- <b-badge v-if="$store.getters.pageError('notches')" variant="danger">!</b-badge> -->
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-notches')" id="accordion-notches" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <Notches />
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#8" v-b-toggle.accordion-endProfiles variant="info" id="header-accordion-endProfiles" :disabled="tabDisabled(7)" :class="{collapsed : !tabDisabled(7)}">
                8 - {{ $t(`endProfiles.title`)}}
                <!-- <b-badge v-if="$store.getters.pageError('endProfiles')" variant="danger">!</b-badge> -->
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-endProfiles')" id="accordion-endProfiles" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <EndProfiles />
              </b-card-body>
            </b-collapse>
          </b-card>

          <!-- <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#9" v-b-toggle.accordion-mountingBracket variant="info" id="header-accordion-mountingBracket">
                9 - {{ $t(`mountingBracket.title`)}}
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-mountingBracket')" id="accordion-mountingBracket" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <MountingBracket />
              </b-card-body>
            </b-collapse>
          </b-card> -->

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#10" v-b-toggle.accordion-finalSummary variant="info" id="header-accordion-finalSummary"  :disabled="tabDisabled(8)">
                9 - {{ $t(`finalSummary.title`)}}
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-finalSummary')" id="accordion-finalSummary" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <FinalSummary />
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#kontakt" v-b-toggle.accordion-contact variant="info" id="header-accordion-contact">
                {{ $t(`contact.title`)}}
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-contact')" id="accordion-contact" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <Contact type="mobile"/>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-item">
            <b-card-header class="header" role="tab">
              <b-btn block href="#expertenansicht" v-b-toggle.accordion-expert variant="info" id="header-accordion-expert">
                 {{ $t(`merchandiserView.title`)}}
                <span class="accordion-toggle-element"></span>
              </b-btn>
            </b-card-header>
            <b-collapse v-on:shown="jump('accordion-expert')" id="accordion-expert" accordion="mobile-accordion" role="tabpanel">
              <b-card-body>
                <MerchandiserView />
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>

    <!-- buttons -->
    <div class="functions">

      <div class="function-buttons">
        <b-btn @click="buttonClickContact()" v-b-toggle.accordion-contact>{{ $t(`pageContent.buttons.contact`)}}</b-btn>
        <a class="button" @click="buttonClickShareMail"  href="">{{ $t(`pageContent.buttons.shareByMail`)}}</a>
        <button @click="buttonClickReset()">{{ $t(`pageContent.buttons.reset`)}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InsulationMaterial from './components/InsulationMaterial.vue'
import ElementWidths from './components/ElementWidths.vue'
import ElementHeights from './components/ElementHeights.vue'
import VacuumPanels from './components/VacuumPanels.vue'
import Notches from './components/Notches.vue'
import EndProfiles from './components/EndProfiles.vue'
import ElementLengths from './components/ElementLengths.vue'
// import MountingBracket from './components/MountingBracket.vue'
import FinalSummary from './components/FinalSummary.vue'
import ElementForm from './components/ElementForm.vue'
import MerchandiserView from './components/MerchandiserView.vue'
import Contact from './components/Contact.vue'

export default {
  name: 'app',
  components: {
    InsulationMaterial,
    ElementWidths,
    ElementHeights,
    VacuumPanels,
    Notches,
    EndProfiles,
    ElementLengths,
    // MountingBracket,
    FinalSummary,
    ElementForm,
    MerchandiserView,
    Contact
  },
  data () {
    return {
      pageErrorElementHeights: false,
      pageErrorElementLengths: false,
      pageErrorElementWidths: false,
      pageErrorVacuumPanels: false,
      pageErrorNotches: false,
      pageErrorEndProfiles: false,
      userDidAction: false,
      tinyStatus: ''
    }
  },
  computed: {
    ...mapGetters([
      'currentPageNumber',
      'currentPage',
      'disableNext',
      'allowStepUpTo',
      'calculatorPages',
      'disabledPage',
      'disabledStatusTab1',
      'disabledStatusTab2',
      'disabledStatusTab3',
      'disabledStatusTab4',
      'disabledStatusTab5',
      'disabledStatusTab6',
      'disabledStatusTab7',
      'disabledStatusTab8',
      'tinyLink',
      'base64Link'
    ])
  },
  methods: {
    jumpToTab: function (val) {
      location.hash = `#${val.toLowerCase()}`
    },
    jump: function (elementID) {
      let element = document.querySelector('#header-' + elementID)
      element.scrollIntoView(
        { block: 'start', behavior: 'smooth' }
      )
    },
    tabChanged: function (selectedTab) {
      let selectTabInt = 0
      if (selectedTab.tab.computedId === 'expertenansicht') {
        selectTabInt = 0
      } else {
        selectTabInt = parseInt(selectedTab.tab.header) - 1
      }
      this.$store.dispatch('setCurrentPage', {
        value: selectTabInt
      })
      if (selectedTab.tab.computedId === 'kontakt') {
        this.createTinyLink(selectedTab)
      }
      this.$store.commit('merchandiserViewStateIncreasement')

      if (selectedTab.tab.computedId === 'expertenansicht') {
        this.virtualPageViews('merchandiserView')
        this.trackTabChange('merchandiserView')
        this.$store.currentTabName = 'merchandiserView'
      } else if (selectedTab.tab.computedId === 'kontakt') {
        this.virtualPageViews('contact')
        this.trackTabChange('contact')
        this.$store.currentTabName = 'contact'
      } else {
        let headline = this.$store.state.calculatorData.calculatorPages[this.$store.state.calculatorData.currentPageNumber].headline
        this.$store.currentTabName = headline
        this.virtualPageViews(headline)
        this.trackTabChange(headline)
      }
    },
    tabDisabled: function (value) {
      return this.$store.state.calculatorData.calculatorPages[value].disabled
    },
    updateCurrentTab: function () {
      if (this.$refs.mytab) {
        var selectNewTab = '#' + (parseInt(this.currentPageNumber) + 1)
        if (this.currentPageNumber === 8) {
          selectNewTab = '#ergebnis'
        } else if (this.currentPageNumber === 9) {
          selectNewTab = '#kontakt'
        }
        this.$refs.mytab.selectTab(selectNewTab)
      }
    },
    reset: function () {
      this.$store.dispatch('resetInputGlobal')
      this.$refs.mytab.selectTab('#1')
    },
    createTinyLink: function (event, callback) {
      let postData = { original_string: this.base64Link }
      this.axios.post(
        process.env.VUE_APP_LOCAL_API_URL + '/shorten',
        postData
      ).then(r => {
        if (r.status === 200) {
          this.$store.commit('updateTinyLink', r.data.answer)
          this.tinyStatus = 'OK'
        } else if (r.status === 400) {
          this.tinyStatus = 'ERORR'
        }
        if (typeof callback === 'function') callback()
      }).catch(error => {
        console.log(error.response)
        if (typeof callback === 'function') callback()
      })
    },
    virtualPageViews: function (headline) {
      let virtualPageURL = '/' + this.$tc(headline + '.virtualPageURL')
      let virtualPageTitle = this.$tc(headline + '.virtualPageTitle')
      this.userDidAction = true
      this.globalGTMFkt('VirtualPageview', '', '', '', '', virtualPageURL, virtualPageTitle)
    },
    trackTabChange: function (headline) {
      let gtmEvent = 'JKK-Events'
      let gtmEventCategory = 'Navigation'
      let gtmEventAction = 'Tab Navigation'

      let virtualPageURL = '/' + this.$tc(headline + '.virtualPageURL')
      let virtualPageTitle = this.$tc(headline + '.virtualPageTitle')
      this.userDidAction = true
      this.globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, virtualPageTitle, '', virtualPageURL, virtualPageTitle)
    },
    buttonClickContact: function () {
      this.jumpToTab(this.$t(`contact.title`))
      this.trackingButton(this.$t(`pageContent.buttons.contact`))
    },
    buttonClickShareMail: function (event) {
      event.preventDefault()
      let self = this
      this.createTinyLink(event, function () {
        const href = 'mailto:?subject=Berechnung%20Jalousiekasten&body=&body=Url%20zur%20Jalousiekasten-Konfiguration:%20' + self.shortenerLink()
        let linkTag = document.createElement('a')
        linkTag.setAttribute('href', href)
        linkTag.click()
        linkTag.remove()
      })
      this.trackingButton(this.$t(`pageContent.buttons.shareByMail`))
    },
    buttonClickReset: function () {
      var check = confirm('Sind Sie sicher, dass alle Eingaben unwiederuflich gelöscht werden sollen?')
      if (check) {
        this.reset()
        this.trackingButton(this.$t(`pageContent.buttons.reset`))
      }
    },
    trackingButton: function (type) {
      let virtualPageURL = '/' + this.$tc(this.currentPage.headline + '.virtualPageURL')
      let virtualPageTitle = this.$tc(this.currentPage.headline + '.virtualPageTitle')
      this.userDidAction = true
      this.globalGTMFkt('JKK-Events', 'Global', 'Button', type, '', virtualPageURL, virtualPageTitle)
    },
    globalGTMFkt: function (event, eventCategory, eventAction, eventLabel, eventvalue, virtualPageURL, virtualPageTitle) {
      if (this.userDidAction) {
        const pusher = {
          event: event || undefined,
          eventCategory: eventCategory || undefined,
          eventAction: eventAction || undefined,
          eventLabel: eventLabel || undefined,
          eventvalue: eventvalue || undefined, // Would better be named eventValue, does this variable name come from the analytics team?
          virtualPageURL: virtualPageURL || undefined,
          virtualPageTitle: virtualPageTitle || undefined
        }
        // Filter out all undefined values
        Object.keys(pusher)
          .filter(key => typeof pusher[key] === 'undefined')
          .forEach(key => delete pusher[key])
        // Only log when not in development, console.log else (for debugging)
        if (process.env.NODE_ENV !== 'development') {
          this.$gtm.push(pusher)
        } else {
          this.$gtm.push(pusher)
          // console.log(pusher)
        }
        this.userDidAction = false
      }
    },
    shortenerLink: function () {
      return process.env.VUE_APP_LOCAL_API_URL.replace(/^\/\//, `${location.protocol}//`) + '/shortener/' + this.tinyLink
    }
  },
  mounted: function () {
    // console.log('--- Mounted Start ---')
    // console.log('--- this ---')
    // console.log(this)
    // console.log('--- calculatorData  ---')
    // console.log(this.$store.state.calculatorData)
    // console.log('--- Mounted End ---')
    // this.updateCurrentTab()
    this.$store.dispatch('initLocalStorage')
  }
}

</script>
